export default function StaticWebsiteConfiguration({ project }) {
  return 'Static Website Configuration'
}
